<template>
  <div class="vehicle-insurance">
    <el-dialog
      :visible.sync="visible"
      fullscreen
      :close-on-click-modal="true"
      :close-on-press-escape="true"
      custom-class="vehicle-insurance-dialog"
      :show-close="true"
      @close="handleClose"
      title="车辆保险管理"
    >
      <div class="header">
        <div>
          车辆号牌：{{ vehicle?.vehicleNo }} 车型：{{ vehicle?.vehicleColor }}-{{ vehicle?.brand2 }}
        </div>
        <div>
          <el-button type="primary" size="small" @click="handleAdd">新增保险</el-button>
        </div>
      </div>
      <div class="divider"></div>
      <div class="content">
        <vehicle-insurance-item
          v-for="(item, idx) in insurances"
          :key="item.id || idx"
          :insurance="item"
          :mode="item.editMode ? 'edit' : 'view'"
          :expanded="item.expanded"
          @edit="handleEdit(idx)"
          @save="(val) => handleSave(idx, val)"
          @cancel="handleCancelEdit(idx)"
          @delete="handleDelete(idx)"
          @toggleCollapse="handleToggleCollapse(idx)"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import VehicleInsuranceItem from "./VehicleInsuranceItem.vue";
import { listVehicleInsurance, getVehicleInfo } from "@/api";

export default {
  name: "VehicleInsurance",
  components: { VehicleInsuranceItem },
  props: {},
  data() {
    return {
      insurances: [],
      vehicleId: null,
      vehicle: null,
      visible: false
    };
  },

  created() {},
  methods: {
    fetchInsurances() {
      if (!this.vehicleId) return;
      listVehicleInsurance({ vehicleId: this.vehicleId }).then((res) => {
        this.insurances = (res.data || []).map((item) => ({ ...item, editMode: false }));
      });
    },
    handleAdd() {
      if (!this.vehicle) {
        this.$message.warning("未获取到车辆信息");
        return;
      }
      this.insurances.unshift({
        insurCom: "",
        insurNum: "",
        insurType: "",
        premium: null,
        insurEff: "",
        insurExp: "",
        vehicleNo: this.vehicle.vehicleNo,
        vehicleId: this.vehicleId,
        insuranceFiles: [],
        editMode: true,
        expanded: true
      });
    },
    handleEdit(idx) {
      this.$set(this.insurances, idx, { ...this.insurances[idx], editMode: true });
    },
    handleDelete(idx) {
      this.insurances.splice(idx, 1);
    },
    handleSave(idx, val) {
      this.insurances[idx] = val;
    },
    handleCancelEdit(idx) {
      // 如果是新加的（无id），取消即删除
      if (!this.insurances[idx].id) {
        this.insurances.splice(idx, 1);
      } else {
        this.$set(this.insurances, idx, { ...this.insurances[idx], editMode: false });
      }
    },

    handleToggleCollapse(idx) {
      this.$set(this.insurances, idx, {
        ...this.insurances[idx],
        expanded: !this.insurances[idx].expanded
      });
    },

    open(vehicleId) {
      this.vehicleId = vehicleId;
      getVehicleInfo(vehicleId).then((res) => {
        this.vehicle = res.data;
      });
      this.fetchInsurances();
      this.visible = true;
    },
    handleClose() {
      this.visible = false;
      this.insurances = [];
      this.vehicle = null;
      this.vehicleId = null;
    }
  }
};
</script>

<style lang="less" scoped>
.vehicle-insurance {
  padding: 20px;
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }
  .divider {
    height: 1px;
    background-color: #e0e0e0;
    margin: 20px 0;
  }
}
::v-deep(.vehicle-insurance-dialog .el-dialog__body) {
  padding: 20px;
}
</style>
